import React, { Component } from 'react'
import {
  DataTable,
  TableBody,
  TableColumn,
  TableHeader,
  TablePagination,
  TableRow
} from 'react-md'

import config from 'config'

import './index.css'

const ListHeader = ({ columns }) => (
  <TableHeader>
    <TableRow>
      { columns.map(column => (
        <TableColumn key={column.key} grow={!!column.grow}>
          {column.dataLabel}
        </TableColumn>
      )) }
    </TableRow>
  </TableHeader>
)

class List extends Component {
  constructor (props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick ({ target }) {
    const { handleClick } = this.props
    if (handleClick && target.tagName === 'TD') {
      handleClick(target.parentElement.id)
    }
  }

  render () {
    let {
      data,
      baseId,
      columns,
      handlePagination,
      page,
      count,
      plain,
      onRowToggle
    } = this.props

    baseId = baseId || 'pagination-table'

    return (
      <div className='pagination-table'>
        <DataTable baseId={baseId} onRowToggle={onRowToggle} plain={plain}>
          <ListHeader columns={columns} />
          <TableBody>
            { data.map(row => (
              <TableRow id={row.id} key={row.id} onClick={this.onClick}>
                { columns.map(col => (
                  <TableColumn key={col.dataField}>
                    {col.buildCell(row[col.dataField])}
                  </TableColumn>
                )) }
              </TableRow>
            )) }
          </TableBody>
          <TablePagination
            {...config.pagination}
            page={page}
            rows={count}
            onPagination={handlePagination}
            rowsPerPageLabel='Rows'
          />
        </DataTable>
      </div>
    )
  }
}

export default List



// WEBPACK FOOTER //
// ./src/components/List/index.js